export const isRangeValid = (adapter, range) => {
  return adapter.isValid(range[0]) && adapter.isValid(range[1]) && !adapter.isBefore(range[1], range[0]);
};
export const isWithinRange = (adapter, day, range) => {
  return isRangeValid(adapter, range) && adapter.isWithinRange(day, range);
};
export const isStartOfRange = (adapter, day, range) => {
  return isRangeValid(adapter, range) && adapter.isSameDay(day, range[0]);
};
export const isEndOfRange = (adapter, day, range) => {
  return isRangeValid(adapter, range) && adapter.isSameDay(day, range[1]);
};
export const formatRange = (adapter, range, formatKey) => {
  if (!isRangeValid(adapter, range)) {
    return null;
  }
  return `${adapter.format(range[0], formatKey)} - ${adapter.format(range[1], formatKey)}`;
};